import * as React from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import { LockIcon, UnLockedIcon } from 'src/assets/icons';
import { COLORS } from 'src/constants';
import { IconButton } from '../../IconButton';

export interface PasswordAdornmentIconProps {
  isVisible: boolean;
  toggleIsVisible: () => void;
}

export const PasswordAdornmentIcon: React.FunctionComponent<PasswordAdornmentIconProps> = ({
  isVisible,
  toggleIsVisible,
}) => {
  const handleMouseDownPassword = (event: React.SyntheticEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  return (
    <InputAdornment position="end">
      <IconButton
        aria-label="toggle password visibility"
        onClick={toggleIsVisible}
        onMouseDown={handleMouseDownPassword}
        edge="end"
      >
        {isVisible ? <UnLockedIcon fill={COLORS.grey1} /> : <LockIcon fill={COLORS.grey1} />}
      </IconButton>
    </InputAdornment>
  );
};
